import "@/App.css";
import { useLenis } from "@/hooks/useLenis";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Showcase } from "@/components/Showcase";
import { Metrics } from "@/components/Metrics";
import { DemoSection } from "@/components/DemoSection";
import { Footer } from "@/components/Footer";

function App() {
  useLenis();
  return (
    <div className="App grain bg-ink text-paper min-h-screen selection:bg-acid">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Showcase />
        <Metrics />
        <DemoSection />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" richColors />
    </div>
  );
}

export default App;
